import { render, staticRenderFns } from "./ComboboxDepartment.vue?vue&type=template&id=01d39316&scoped=true&"
import script from "./ComboboxDepartment.vue?vue&type=script&lang=js&"
export * from "./ComboboxDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ComboboxDepartment.vue?vue&type=style&index=0&id=01d39316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d39316",
  null
  
)

export default component.exports